<template>
  <div id="seriesFilterList" class="product-filters">
    <h3 class="no-underline">Search</h3>
    <div class="filter part-number-search">
      <label for="part_number" class="is-sr-only">Part Number</label>
      <input type="text" v-model="partNumberSearchFilter" id="part_number" placeholder="Enter part number">
      <button type="button"><span class="material-icons" data-localizer="ignore">search</span></button>
    </div>

    <div id="filter-toggle" class="toggle-filters">
      <h3 class="no-underline is-hidden-mobile">Filter</h3>
      <a @click="toggleFilters()" class="h3 filter-header is-hidden-tablet">Filter</a>
      <a v-if="activeFilters" @click="toggleFilters()" class="activate-filters is-hidden-tablet">Apply Filters</a>
      <a v-if="activeFilters" @click="clearFilters()" class="clear-filters">Clear Filters</a>
    </div>

    <div id="search-filters-wrapper" class="search-filters">
      <div v-if="filterOptions.hasOwnProperty('pressureRatings')" class="filter" id="pressureRatings-wrapper">
        <h4><a @click="toggleFilter('pressureRatings')">{{ filterOptions['pressureRatings'].label }}</a></h4>
        <div class="options-wrapper">
          <ul>
            <li v-for="(option, index) in filterOptions['pressureRatings'].options" :key="index">
              <label>
                <input type="checkbox" v-model="pressureRatingsSearchFilter" :value="option.id" />
                <span>{{ option.name }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="filterOptions.hasOwnProperty('connectionTypes')" class="filter" id="connectionTypes-wrapper">
        <h4><a @click="toggleFilter('connectionTypes')">{{ filterOptions['connectionTypes'].label }}</a></h4>
        <div class="options-wrapper">
          <ul>
            <li v-for="(option, index) in filterOptions['connectionTypes'].options" :key="index">
              <label :data-type="imageConnectionTypes.includes(option.name) ? option.name : null">
                <input type="checkbox" v-model="connectionTypesSearchFilter" :value="option.id" />
                <span>{{ option.name }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="filterOptions.hasOwnProperty('sizes')" class="filter" id="sizes-wrapper">
        <h4><a @click="toggleFilter('sizes')">{{ filterOptions['sizes'].label }}</a></h4>
        <div class="options-wrapper">
          <ul>
            <li v-for="(option, index) in filterOptions['sizes'].options" :key="index">
              <label>
                <input type="checkbox" v-model="sizesSearchFilter" :value="option.id" />
                <span>{{ option.name }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="filterOptions.hasOwnProperty('applicationTypes')" class="filter" id="applicationTypes-wrapper">
        <h4><a @click="toggleFilter('applicationTypes')">{{ filterOptions['applicationTypes'].label }}</a></h4>
        <div class="options-wrapper">
          <ul>
            <li v-for="(option, index) in filterOptions['applicationTypes'].options" :key="index">
              <label>
                <input type="checkbox" v-model="applicationTypesSearchFilter" :value="option.id" />
                <span>{{ option.name }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="filterOptions.hasOwnProperty('actuationMethods')" class="filter" id="actuationMethods-wrapper">
        <h4><a @click="toggleFilter('actuationMethods')">{{ filterOptions['actuationMethods'].label }}</a></h4>
        <div class="options-wrapper">
          <ul>
            <li v-for="(option, index) in filterOptions['actuationMethods'].options" :key="index">
              <label>
                <input type="checkbox" v-model="actuationMethodsSearchFilter" :value="option.id" />
                <span>{{ option.name }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="filterOptions.hasOwnProperty('industries')" class="filter" id="industries-wrapper">
        <h4><a @click="toggleFilter('industries')">{{ filterOptions['industries'].label }}</a></h4>
        <div class="options-wrapper">
          <ul>
            <li v-for="(option, index) in filterOptions['industries'].options" :key="index">
              <label>
                <input type="checkbox" v-model="industriesSearchFilter" :value="option.id" />
                <span>{{ option.name }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useModelWrapper } from '@/utils/modelWrapper'

export default {
  name: 'SeriesSearchFilters',
  data () {
    return {
      imageConnectionTypes: [
        '45 Flare',
        'Barbed Tube',
        'Beaded Tube',
        'BSPT/BSPP (G) External',
        'BSPT/BSPP (G) Internal',
        'Catheters',
        'Compression Fitting',
        'CoreMax',
        'CoreMax Seat',
        'Expanded Tube',
        'Flared Tube',
        'Formed Tube',
        'Fuel Rail',
        'Gas External',
        'Gas Internal',
        'Gas Yoke',
        'Hansen Tips',
        'Holes/Bores',
        'JIC 37 Flare',
        'JIC 37 Swivel Nut',
        'Luers',
        'Metric External',
        'Metric Internal',
        'NPT External',
        'NPT Internal',
        'O-Ring Boss/Flare Ports',
        'ORFS Swivel Nut',
        'PCU Tips',
        'Pressure Relief Valve',
        'Straight Tube',
        'Swaged Tube'
      ]
    }
  },
  props: {
    partNumberFilter: String,
    pressureRatingsFilter: Array,
    connectionTypesFilter: Array,
    sizesFilter: Array,
    applicationTypesFilter: Array,
    actuationMethodsFilter: Array,
    industriesFilter: Array,
    filterOptions: Object
  },
  setup (props, { emit }) {
    return {
      partNumberSearchFilter: useModelWrapper(props, emit, 'partNumberFilter'),
      pressureRatingsSearchFilter: useModelWrapper(props, emit, 'pressureRatingsFilter'),
      connectionTypesSearchFilter: useModelWrapper(props, emit, 'connectionTypesFilter'),
      sizesSearchFilter: useModelWrapper(props, emit, 'sizesFilter'),
      applicationTypesSearchFilter: useModelWrapper(props, emit, 'applicationTypesFilter'),
      actuationMethodsSearchFilter: useModelWrapper(props, emit, 'actuationMethodsFilter'),
      industriesSearchFilter: useModelWrapper(props, emit, 'industriesFilter')
    }
  },
  computed: {
    activeFilters () {
      let activeFilters = false

      if (this.partNumberSearchFilter.length) {
        activeFilters = true
      }
      if (this.pressureRatingsSearchFilter.length) {
        activeFilters = true
      }
      if (this.connectionTypesSearchFilter.length) {
        activeFilters = true
      }
      if (this.sizesSearchFilter.length) {
        activeFilters = true
      }
      if (this.applicationTypesSearchFilter.length) {
        activeFilters = true
      }
      if (this.actuationMethodsSearchFilter.length) {
        activeFilters = true
      }
      if (this.industriesSearchFilter.length) {
        activeFilters = true
      }

      return activeFilters
    }
  },
  methods: {
    toggleFilters: function () {
      document.getElementById('seriesFilterList').classList.toggle('open')

      var elements = document.getElementsByClassName('filter open')
      while (elements.length > 0) {
        elements[0].classList.remove('open')
      }
    },
    toggleFilter: function (type) {
      document.getElementById(type + '-wrapper').classList.toggle('open')
    },
    clearFilters: function () {
      this.partNumberSearchFilter = ''
      this.pressureRatingsSearchFilter = []
      this.connectionTypesSearchFilter = []
      this.sizesSearchFilter = []
      this.applicationTypesSearchFilter = []
      this.actuationMethodsSearchFilter = []
      this.industriesSearchFilter = []
    }
  }
}
</script>
